import React, { useEffect, useState } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  
  Input,
  Button,
  Spinner,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { HiEye } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import Swal from 'sweetalert2';
import { useDispatch } from "react-redux";
// import { FaBell } from "react-icons/fa";
import { BsFilterSquareFill } from "react-icons/bs";
function StoreList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [counting, setCounting] = useState({});
  const [alertLoader, setAlertLoader] = useState(false);
  const [showAlter, setShowAlter] = useState(false);
  const pageSize = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [loader, setLoader] = useState(false);
  const [userId, setUserId] = useState(null);

  const fetchUsers = async (pageNumber, query = "" ,status="") => {
    try {
      setLoader(true);
      const filterData = {
        pageSize,
        pageNumber,
        sortField: "createdAt",
        sortOrder: "asc",
        role: "store",
        search: query,
        isVerified: status,
      };
      const getAllStores = await ApiClient.post(
        "api/admin/findAllUsers",
        filterData,
        true,
        dispatch
      );
      setUsers(getAllStores.data.users);
      setCounting(getAllStores.data);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage, searchQuery,statusFilter);
  }, [currentPage, searchQuery,statusFilter]);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const openAlertDialog = (id) => {
    setUserId(id);
    setShowAlter(true);
  };
  const handleDelete = async () => {
    if (userId) {
      try {
        setAlertLoader(true);
        const deleteUser = await ApiClient.delete(
          `api/admin/delete-users`,
          { id: userId },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchUsers(currentPage, searchQuery);
        toast.success(deleteUser.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  const viewDetails = (id) => {
    navigate(`/admin/store/details?id=${id}`);
  };
 


  const handleStatusChange = (e) => {
   const {value} =e.target
    setStatusFilter(value);
    setCurrentPage(1);
  };
  return (
    <>
      <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Stores</h4>
      </div>
        <Row>
          <Col md="12">
            <Card>
            <CardHeader>
                <Row>
                  <Col md="12" className="d-flex align-items-center justify-content-between">
                    <InputGroup className="no-border search-input" style={{ maxWidth: "500px" }}>
                      <Input
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                        <InputGroupText>
                          <i className="nc-icon nc-zoom-split" />
                        </InputGroupText>
                    </InputGroup>
                    <Col md="3">
                    <Button
                      color="primary"
                      className="common-button mt-0"
                      onClick={() => navigate("/admin/store/add")}
                    >
                      Add Store
                    </Button>
                  </Col>
                    <FormGroup className="filter-dropdown d-flex align-items-center">
                      <Label className="mr-4 mb-0" style={{ fontWeight: 'bold', fontSize:"1rem"}}>Filter</Label>
                      <Input
                        type="select"
                        id="statusFilter"
                        value={statusFilter}
                        onChange={handleStatusChange}
                      >
                        <option value="">All</option>
                        <option value="true">Verified</option>
                        <option value="false">Pending</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Sr. No</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users?.map((user, index) => (
                          <tr key={user._id}>
                            <td>{pageSize * (currentPage - 1) + index + 1}</td>
                            <td>{user?.firstName}</td>
                            <td>{user?.lastName}</td>
                            <td>{user?.email}</td>
                            <td>
                              {user?.isVerified ? (
                                <Badge color="success" pill>
                                  verified
                                </Badge>
                              ) : (
                                <Badge color="warning" pill>
                                  pending
                                </Badge>
                              )}
                            </td>
                            <td className="text-center">
                              <span
                                className="action-icon"
                                onClick={() => viewDetails(user._id)}
                              >
                                <HiEye />
                              </span>
                              {/* <span className="action-icon action-icon-yellow"><MdModeEdit  /></span> */}
                              <span
                                className="action-icon action-icon-red"
                                onClick={() => openAlertDialog(user._id)}
                              >
                                <MdDelete />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {counting?.currentPage} of {counting?.totalPages}
                 
                        <strong className="ml-3">Total records: </strong>
                        {counting?.totalUsers}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === counting?.totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                    
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showAlter && (
        <Swal
          danger
          showCancel
          confirmBtnText={
            alertLoader ? (
              <span>
                Confirm <Spinner size="sm" />
              </span>
            ) : (
              "Confirm"
            )
          }
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={handleDelete}
          onCancel={() => setShowAlter(false)}
          focusCancelBtn
        >
          You want to delete this store
        </Swal>
      )}
    </>
  );
}

export default StoreList;
